module.exports = __webpack_public_path__ + "static/img/title_a@2x.c2013c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbPlatformInfoMin/title_a@2x.png
// module id = l4Hn
// module chunks = 69